import { Typography, makeStyles } from "@material-ui/core";
import React, { useState } from "react";
import GovGrCard from "../../../../components/GovGrCard";
import useLocale from "../../../../hooks/useLocale";
import CustomAlert from "../../../components/CustomAlert";
import CustomTable from "../../../../components/GovGrMaterialTable";
import dayjs from "dayjs";
import GovGrButton from "../../../../components/GovGrButton";
import GatewayDataViewDetails from "./GatewayDataViewDetails";
import { ContactSupportOutlined } from "@material-ui/icons";

const useStyles = makeStyles({
  root: {
    "& .MuiTextField-root": {
      margin: 15,
    },
    "& .MuiInputBase-root.Mui-disabled": {
      color: "rgba(0, 0, 0, 1)", // (default alpha is 0.38)
    },
  },
  card: {
    minWidth: 275,
    marginTop: 15,
    marginBottom: 15,
    alignSelf: "center",
  },
  viewDetails: {
    width: 700,
    height: 400,
  },
});

const GatewayDataDocuments = ({ data }) => {
  const classes = useStyles();
  const { t } = useLocale();
  const [viewData, setViewData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Below we construct an array of Object which each object has the different fields with status so we can add it to the table
  const dataTransformed = [];

  Object.entries(data).forEach(([key, value]) => {
    if (key.includes("criminal")) {
      let filteredData = dataTransformed.filter((item) => {
        return (
          Object.keys(item).filter((filteredItem) =>
            filteredItem.includes("criminal")
          ).length > 0
        );
      });
      if (filteredData.length > 0) {
        const index = dataTransformed.indexOf(filteredData[0]);
        dataTransformed[index] = {
          id: index + 1,
          dscr: "criminal",
          ...filteredData[0],
          ...Object.fromEntries([[key, value]]),
        };
      } else {
        dataTransformed.push(Object.fromEntries([[key, value]]));
      }
    }

    if (key.includes("stratologia")) {
      let filteredData = dataTransformed.filter((item) => {
        return (
          Object.keys(item).filter((filteredItem) =>
            filteredItem.includes("stratologia")
          ).length > 0
        );
      });

      if (filteredData.length > 0) {
        const index = dataTransformed.indexOf(filteredData[0]);

        dataTransformed[index] = {
          id: index + 1,
          dscr: "stratologia",
          ...filteredData[0],
          ...Object.fromEntries([[key, value]]),
        };
      } else {
        dataTransformed.push(Object.fromEntries([[key, value]]));
      }
    }

    if (key.includes("student_attendance")) {
      let filteredData = dataTransformed.filter((item) => {
        return (
          Object.keys(item).filter((filteredItem) =>
            filteredItem.includes("student_attendance")
          ).length > 0
        );
      });

      if (filteredData.length > 0) {
        const index = dataTransformed.indexOf(filteredData[0]);
        dataTransformed[index] = {
          id: index + 1,
          dscr: "student_attendance",
          ...filteredData[0],
          ...Object.fromEntries([[key, value]]),
        };
      } else {
        dataTransformed.push(Object.fromEntries([[key, value]]));
      }
    }
    if (key.includes("digital_diploma")) {
      let filteredData = dataTransformed.filter((item) => {
        return (
          Object.keys(item).filter((filteredItem) =>
            filteredItem.includes("digital_diploma")
          ).length > 0
        );
      });

      if (filteredData.length > 0) {
        const index = dataTransformed.indexOf(filteredData[0]);
        dataTransformed[index] = {
          id: index + 1,
          dscr: "digital_diploma",
          ...filteredData[0],
          ...Object.fromEntries([[key, value]]),
        };
      } else {
        dataTransformed.push(Object.fromEntries([[key, value]]));
      }
    }
    if (key.includes("mitroo")) {
      // NOT YET IMPLEMENTED ON BACKEND , WE NEED IN THE APPLICATION TO BE FIELDS WHICH EACH FIELD INCLUDES mitroo , related to ticket YENTHIRIDA-342
      let filteredData = dataTransformed.filter((item) => {
        return (
          Object.keys(item).filter((filteredItem) =>
            filteredItem.includes("mitroo")
          ).length > 0
        );
      });
      if (filteredData.length > 0) {
        const index = dataTransformed.indexOf(filteredData[0]);
        dataTransformed[index] = {
          id: index + 1,
          dscr: "mitroo",
          ...filteredData[0],
          ...Object.fromEntries([[key, value]]),
        };
      } else {
        dataTransformed.push(Object.fromEntries([[key, value]]));
      }
    }
  });

  const columns = [
    {
      title: t("Name"),
      field: "dscr",
      render: (rowData) => {
        return t(`${rowData.dscr}`);
      },
    },
    {
      title: t("To Status"),
      field: "newStatus",
      render: (rowData) => {
        let status = "";
        for (let [key, value] of Object.entries(rowData)) {
          if (key.includes("status")) {
            status = value;
          }
        }

        return <>{status}</>;
      },
    },
    {
      title: t("Data"),
      field: "view",
      render: (rowData) => {
        return (
          <GovGrButton
            variant="secondary"
            buttonText={t("View")}
            onClick={() => {
              setViewData(rowData);
              setIsModalOpen(true);
            }}
          />
        );
      },
    },
  ];
  return (
    <div className={classes.root}>
      <GovGrCard>
        <Typography variant="h3" color="textPrimary" gutterBottom>
          {t("Gateway Data")}
        </Typography>
        <div>
          <CustomAlert
            // open={isError}
            close={() => {
              // refetch();
            }}
            message={t("A network error occured, please try again later")}
          />

          <CustomTable
            options={{
              showTitle: false,
            }}
            // isLoading={isLoading}
            columns={columns}
            data={dataTransformed}
          />
        </div>
      </GovGrCard>
      <GatewayDataViewDetails
        applId={data.id}
        open={isModalOpen}
        close={() => setIsModalOpen(false)}
        data={viewData}
      />
    </div>
  );
};

export default GatewayDataDocuments;
